export default "__VITE_ASSET__BsoqHWGf__"